/* eslint-disable react/jsx-curly-newline */
import React, { memo, lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';

import Layout from 'components/Layout';

// import AuthorizedRoute from './api/AuthorizedRoute';
import OrganizationAccessRoute from './utils/OrganizationAccessRoute';

import defaultTheme from './themes/default';
import techpackTheme from './themes/techpack';
import costTheme from './themes/cost';
// import productionTheme from './themes/production';
import calculationsTheme from './themes/calculations';

import SpecificationsRouts from './routs/Specifications';
import CostRouts from './routs/Cost';
import OrdersRouts from './routs/Orders';
import WarehouseReleasesRouts from './routs/WarehouseReleases';
import UserProfileRouts from './routs/UserProfile';
import CalculationsRouts from './routs/Calculations';
import OrganizationRouts from './routs/Organization';

import LandingPage from './views/LandingPage/LandingPage';
import SpecificationParametersRoutes from './routs/SpecificationParametersRoutes';

const InformationPanel = lazy(() => import('./views/Authentication/InformationPanel'));

const NoMatch = lazy(() => import('./views/NoMatch'));
const NoOrganization = lazy(() => import('./views/NoOrganization'));

const withTheme = (component, theme) => (
  <ThemeProvider theme={theme}>
    <Layout>{component}</Layout>
  </ThemeProvider>
);

const Routs = () => (
  <Switch>
    <Route path="/information-panel">
      <Suspense fallback="Loading...">
        <InformationPanel />
      </Suspense>
    </Route>

    <Route path="/no-organization">
      <Suspense fallback="Loading...">
        <ThemeProvider theme={defaultTheme}>
          <NoOrganization />
        </ThemeProvider>
      </Suspense>
    </Route>

    {/* <AuthorizedRoute path="/"> */}
    {/* <ThemeProvider theme={defaultTheme}> */}
    <OrganizationAccessRoute>
      <Switch>
        <Route path="/landing-page">
          <LandingPage />
        </Route>
        <Route
          path="/specifications"
          render={({ match }) => withTheme(<SpecificationsRouts match={match} />, techpackTheme)}
        />
        <Route
          path="/cost"
          render={({ match }) => withTheme(<CostRouts url={match?.url} />, costTheme)}
        />

        <Route
          path="/organization"
          render={({ match }) => withTheme(<OrganizationRouts url={match?.url} />, techpackTheme)}
        />

        <Route
          path="/specification-parameters"
          render={({ match }) =>
            withTheme(<SpecificationParametersRoutes url={match?.url} />, techpackTheme)
          }
        />

        <Route
          path="/orders"
          render={({ match }) => withTheme(<OrdersRouts url={match?.url} />, techpackTheme)}
        />

        <Route
          path="/calculations"
          render={({ match }) =>
            withTheme(<CalculationsRouts url={match?.url} />, calculationsTheme)
          }
        />

        <Route
          path="/warehouse-releases"
          render={({ match }) =>
            withTheme(<WarehouseReleasesRouts url={match?.url} />, techpackTheme)
          }
        />

        <Route
          path="/user-profile"
          render={({ match }) => withTheme(<UserProfileRouts url={match?.url} />, techpackTheme)}
        />

        <Route path="/" exact>
          <Redirect to="/landing-page" />
        </Route>

        <Route exact path="*">
          {withTheme(<NoMatch />, defaultTheme)}
        </Route>
      </Switch>
    </OrganizationAccessRoute>
    {/* </ThemeProvider> */}
    {/* </AuthorizedRoute> */}
  </Switch>
);

export default memo(Routs);
